<template>
  <div class="ajuste_area">
    <!-- Fonte -->
    <label>Fonte dos textos</label>
    <FontPicker :valor="tela.fonte" :onAtualizarFonte="(novaFonte) => alterarValorTela('fonte', novaFonte)" />

    <!-- Textos -->
    <template v-for="(item, index) in camposTexto" :key="index">
      <label>{{ item.label }}</label>
      <textarea spellcheck="false" rows="2" :placeholder="item.placeholder" v-model="tela[item.propriedade]" @input="iniciarDebounce(item.propriedade)" v-redimensionar-textarea></textarea>
    </template>

    <!-- Layout -->
    <label>Layout da tela</label>
    <div class="layouts">
      <button v-for="layout in layouts" :key="layout.valor" :class="{ ativo: tela.layout === layout.valor }" @click="alterarValorTela('layout', layout.valor)">
        <img :src="layout.imagem" />
      </button>
    </div>

    <!-- Cores -->
    <template v-for="(item, index) in camposCores" :key="`cor-${index}`">
      <label>{{ item.label }}</label>
      <ColorPicker :valor="tela[item.propriedade]" :onAtualizarCor="(novaCor) => atualizarCor(item.propriedade, novaCor)" />
    </template>

    <!-- Imagens -->
    <Imagem label="Capa Desktop" tamanho="1920x1080" v-model:url="tela.imagemCapa" :imagemPreenchida="tela.imagemCapa" />

    <Imagem label="Capa Mobile" tamanho="700x300" v-model:url="tela.imagemCapaMobile" :imagemPreenchida="tela.imagemCapaMobile" />
  </div>
</template>

<script setup>
import { computed, watch, onUnmounted, onMounted, reactive } from 'vue'
import { useStoreEditar, useStoreAreas } from '@stores'
import FontPicker from '@components/global/elementos/FontPicker.vue'
import ColorPicker from '@components/global/elementos/ColorPicker.vue'
import Imagem from '@components/global/elementos/Imagem.vue'

const storeEditar = useStoreEditar()
const storeAreas = useStoreAreas()

const tela = computed(() => storeEditar.personalizacao?.telaCurso || {})

const state = reactive({
  temporizador: null,
  inicializado: false,
  alteracoesPendentes: {},
  tempoDebounce: 400
})

const layouts = [
  {
    valor: 'um',
    imagem: 'https://central-statics.nyc3.digitaloceanspaces.com/levelmember/imagens/default/telas/layout-curso-1.svg'
  },
  {
    valor: 'dois',
    imagem: 'https://central-statics.nyc3.digitaloceanspaces.com/levelmember/imagens/default/telas/layout-curso-2.svg'
  },
  {
    valor: 'tres',
    imagem: 'https://central-statics.nyc3.digitaloceanspaces.com/levelmember/imagens/default/telas/layout-curso-3.svg'
  }
]

const camposTexto = [{ propriedade: 'textoBotao', label: 'Texto dos botões', placeholder: 'Digite aqui' }]

const camposCores = [
  { propriedade: 'corFundo', label: 'Fundo' },
  { propriedade: 'corQuadro', label: 'Quadros' },
  { propriedade: 'corTitulos', label: 'Títulos' },
  { propriedade: 'corTags', label: 'Tags' },
  { propriedade: 'corFundoBotao', label: 'Fundo dos botões' },
  { propriedade: 'corTextoBotao', label: 'Textos dos botões' },
  { propriedade: 'corPosicaoTexto', label: 'Textos das posições' },
  { propriedade: 'corPosicaoFundo', label: 'Fundo das posições' },
  { propriedade: 'corCaminho', label: 'Cor dos botões secundários' }
]

function alterarValorTela(propriedade, valor) {
  if (!tela.value || !propriedade) return

  tela.value[propriedade] = valor
  iniciarDebounce(propriedade)
}

function atualizarCor(propriedade, novaCor) {
  alterarValorTela(propriedade, `#${novaCor}`)
}

function iniciarDebounce(propriedade) {
  if (!state.inicializado) return

  state.alteracoesPendentes[propriedade] = true

  if (state.temporizador) clearTimeout(state.temporizador)

  state.temporizador = setTimeout(() => {
    salvarAlteracoes()
    state.alteracoesPendentes = {}
  }, state.tempoDebounce)
}

watch(
  () => tela.value?.layout,
  (novoValor, valorAntigo) => {
    if (novoValor !== valorAntigo && state.inicializado) {
      iniciarDebounce('layout')
    }
  }
)

watch(
  () => [tela.value?.imagemCapa, tela.value?.imagemCapaMobile],
  (novosValores, valoresAntigos) => {
    if (JSON.stringify(novosValores) !== JSON.stringify(valoresAntigos) && state.inicializado) {
      iniciarDebounce('imagens')
    }
  },
  { deep: true }
)

async function salvarAlteracoes() {
  const idArea = storeAreas.area?._id
  if (!idArea || !tela.value) return

  try {
    const payload = {
      personalizacao: {
        telaCurso: tela.value
      }
    }

    await storeAreas.alterarDados(idArea, payload, true)
  } catch (erro) {
    console.error('Erro ao salvar personalizações:', erro)
  }
}

onMounted(() => {
  setTimeout(() => {
    state.inicializado = true
  }, 500)
})

onUnmounted(() => {
  if (state.temporizador) {
    clearTimeout(state.temporizador)
  }
})
</script>
